/* eslint-disable @typescript-eslint/camelcase */
import { get, isEmpty } from 'lodash'
import { format } from 'date-fns'

export function getPrice(value, type) {
  const price = get(value, type, null)
  return price === '' ? null : price
}

export default function(values, objectId, calendarId) {
  return {
    id_calendar: calendarId,
    id_object: objectId,
    periods: values.dates.map(date => ({
      end: format(date.to, 'YYYY-MM-DD'),
      start: format(date.from, 'YYYY-MM-DD'),
    })),
    prices: {
      extrabed: {
        long: getPrice(values, 'additional.long_stay'),
        short: getPrice(values, 'additional.short_stay'),
        standard: getPrice(values, 'additional.standard'),
        weekend: getPrice(values, 'additional.weekend'),
      },
      kids: !isEmpty(values.kid)
        ? values.kid.map(k => ({
            kid_id: k.id,
            long:
              k.long_stay !== undefined && k.long_stay !== ''
                ? k.long_stay
                : null,
            short:
              k.short_stay !== undefined && k.short_stay !== ''
                ? k.short_stay
                : null,
            standard:
              k.standard !== undefined && k.standard !== '' ? k.standard : null,
            weekend:
              k.weekend !== undefined && k.weekend !== '' ? k.weekend : null,
          }))
        : undefined,
      long: mapPricesToPersonArr(values, 'long_stay'),
      short: mapPricesToPersonArr(values, 'short_stay'),
      standard: mapPricesToPersonArr(values, 'standard'),
      weekend: mapPricesToPersonArr(values, 'weekend'),
    },
    restrictions: someValue(values, [
      'details_min_time',
      'details_max_length',
      'details_max_time',
      'details_min_length',
      'details_departure_close',
      'details_min_arrival_length',
      'details_arrival_close',
      'details_exact_stay',
      'details_max_arrival_length',
    ])
      ? {
          restriction_close_at_arrival: isEmpty(values.details_arrival_close)
            ? undefined
            : values.details_arrival_close.some(d => d),
          restriction_close_at_arrival_days: arrayToWeekDays(
            values.details_arrival_close,
          ),
          restriction_close_at_departure: isEmpty(
            values.details_departure_close,
          )
            ? undefined
            : values.details_departure_close.some(d => d),
          restriction_close_at_departure_days: arrayToWeekDays(
            values.details_departure_close,
          ),
          restriction_exact_stay: values.details_exact_stay
            ? values.details_exact_stay[7]
            : undefined,
          restriction_exact_stay_days: arrayToWeekDays(
            values.details_exact_stay,
          ),
          restriction_max_before_arrival: arrayToHours(values.details_max_time),
          restriction_max_before_arrival_days: arrayToWeekDays(
            values.details_max_time,
          ),
        restriction_max_stay_thru: values.details_max_arrival_length
            ? values.details_max_arrival_length[7]
            : undefined,
        restriction_max_stay_thru_days: arrayToWeekDays(
            values.details_max_arrival_length,
          ),
        restriction_max_stay: values.details_max_length
            ? values.details_max_length[7]
            : undefined,
        restriction_max_stay_days: arrayToWeekDays(
            values.details_max_length,
          ),

          restriction_min_before_arrival: arrayToHours(values.details_min_time),
          restriction_min_before_arrival_days: arrayToWeekDays(
            values.details_min_time,
          ),
        restriction_min_stay: values.details_min_length
            ? values.details_min_length[7]
            : undefined,
        restriction_min_stay_days: arrayToWeekDays(
            values.details_min_length,
          ),
        restriction_min_stay_thru: values.details_min_arrival_length
            ? values.details_min_arrival_length[7]
            : undefined,
        restriction_min_stay_thru_days: arrayToWeekDays(
            values.details_min_arrival_length,
          ),
          // restriction_min_stay: values.details_min_length
          //   ? values.details_min_length[7]
          //   : undefined,
          // restriction_min_stay_days: arrayToWeekDays(values.details_min_length),
          // restriction_min_stay_thru: values.details_min_arrival_length
          //   ? values.details_min_arrival_length[7]
          //   : undefined,
          // restriction_min_stay_thru_days: arrayToWeekDays(
          //   values.details_min_arrival_length,
          // ),
        }
      : {},
    rooms: values.selectedRooms.map(r => Number(r)),
  }
}

function mapPricesToPersonArr(values, type) {
  const arr = []

  if (!isEmpty(values.price) || !('adult' in values)) {
    arr[+values.roomSize] = getPrice(values.price, type)
    return arr
  } else if ('adult' in values) {
    Object.entries(values.adult).forEach(([key, value]) => {
      arr[Number(key) + 1] = getPrice(value, type)
    })

    return arr
  }
}

function arrayToWeekDays(arr) {
  if (isEmpty(arr)) {
    return undefined
  }
  const arrcpy = [...arr]
  arrcpy.length = 7
  arrcpy.push(arrcpy.shift())

  return [0, ...arrcpy.map(x => (x ? 1 : 0))]
}

function arrayToHours(arr) {
  if (isEmpty(arr)) {
    return undefined
  }
  const days = arr[7]
  const hours = arr[8]
  if (!days && !hours) {
    return undefined
  }
  if (hours) {
    if (days) {
      return Number(days) * 24 + Number(hours)
    }
    return Number(hours)
  }
  if (days && !hours) {
    return Number(days) * 24
  }
}

function someValue(values, arr: string[]) {
  return arr.map(r => get(values, r, false)).some(r => !isEmpty(r))
}
